import noImage from '../assets/image/app/no-image.png';

export const fileRender = (url) => url ? `${process.env.REACT_APP_DOMAIN}${url}` : 'N/A';
export const photoRender = (url) => url ? `${process.env.REACT_APP_DOMAIN}${url}` : noImage;